module.exports = __webpack_public_path__ + "static/media/img_38.6d3cc3b9.png";